import { useEffect, useState } from 'react'

import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { Checkbox } from '@wartek-id/checkbox-v1'

import { assetUrl } from 'utils/url'
import {
  removeDummyDemoData,
  removeHandlers,
} from 'app/KinerjaPage/utils/demo-api'

type Props = Omit<DialogProps, 'children'> & {
  onConfirm?: () => void
}

export default function DialogCloseDemoMode(props: Props) {
  const [agree, setAgree] = useState(false)

  useEffect(() => {
    if (!props.isOpen) {
      setAgree(false)
    }
  }, [props.isOpen])

  return (
    <Dialog size="sm" {...props}>
      <DialogOverlay />
      <DialogContent>
        <div className="p-6">
          <img
            alt="Illustration Warning Demo Mode"
            src={assetUrl('/illustrations/img-to-do-list-document.png')}
            width={84}
            height={84}
          />

          <Text variant="display-md" className="mt-4">
            Data simulasi tidak akan tersimpan.
            <br /> Lanjut keluar?
          </Text>

          <Text variant="body" className="!text-base mt-4">
            Jika lanjut, Anda harus mengulang simulasi dari awal.
          </Text>

          <Checkbox
            checked={agree}
            onChange={(e) => setAgree(e.target.checked)}
            className="mt-4"
          >
            Saya mengerti bahwa data simulasi tidak akan tersimpan jika saya
            keluar dari halaman.
          </Checkbox>

          <div className="flex gap-5 mt-8">
            <Button
              size="lg"
              onClick={() => {
                props?.onClose()
              }}
            >
              Kembali
            </Button>

            <Button
              size="lg"
              variant="ghost"
              disabled={!agree}
              onClick={() => {
                // we don't want the beforeunload listener to trigger here
                if (removeHandlers) removeHandlers()

                removeDummyDemoData()

                props?.onClose()
                props?.onConfirm()
              }}
            >
              Lanjut keluar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
